import React, { SetStateAction } from "react";
import { FaChevronDown, FaDownload } from "react-icons/fa";

import useDropdown from "../../../hooks/useDropDown";

const fontFamilies = [
  "Helvetica",
  "Times-Roman",
  "Courier",
  "Symbol",
  "ZapfDingbats",
];
const fontSizes = ["8", "10", "12", "14", "16", "18", "24", "36"];
function TextToolbar({
  selectedFont,
  setSelectedFont,
  selectedSize,
  setSelectedSize,
  updateTextStyle,
  ToggleTextStyle,
  handleDownload,
  downloadPdf,
  setSelectedColor,
}: {
  selectedFont: string;
  setSelectedFont: React.Dispatch<React.SetStateAction<string>>;
  selectedSize: string;
  setSelectedSize: React.Dispatch<React.SetStateAction<string>>;
  updateTextStyle: (object: object) => void;
  ToggleTextStyle: (style: string) => void;
  handleDownload: () => void;
  downloadPdf?: boolean;
  setSelectedColor: React.Dispatch<SetStateAction<string>>;
}) {
  const { dropdownRef, dropdowns, setDropdowns, closeDropDown } = useDropdown();
  return (
    <div className="w-full bg-white p-5 flex items-center justify-between shadow-lg border-b">
      <div className="w-full flex items-center gap-x-5">
        <div className="flex items-center gap-x-5 border-r border-gray-300 pr-2">
          <span className="text-sm font-semibold text-black">Colours</span>
          <div
            className="w-[20px] h-[20px] cursor-pointer rounded-full hover:border-2 hover:border-gray-500 bg-black"
            onClick={() => {
              updateTextStyle({ fill: "#000000" });
              setSelectedColor("#000000");
            }}
          />
          <div
            className="w-[20px] h-[20px] cursor-pointer rounded-full hover:border-2 hover:border-gray-500 bg-red-700"
            onClick={() => {
              updateTextStyle({ fill: "#d32f2f" });
              setSelectedColor("#d32f2f");
            }}
          />
          <div
            className="w-[20px] h-[20px] cursor-pointer rounded-full hover:border-2 hover:border-gray-500 bg-blue-700"
            onClick={() => {
              updateTextStyle({ fill: "#1976d2" });
              setSelectedColor("#1976d2");
            }}
          />
        </div>

        {/* Font Family */}
        <div className="flex items-center relative gap-x-3 border-r pr-2">
          <span className="text-sm font-semibold text-black">Font</span>
          <div
            className="border flex items-center p-1 justify-between shadow-border rounded-lg h-[5vh] w-32 cursor-pointer bg-white relative"
            onClick={() => setDropdowns({ ...dropdowns, fontFamilyBox: true })}
          >
            <span className="text-sm">{selectedFont}</span>
            <FaChevronDown size={10} />
            {dropdowns.fontFamilyBox && (
              <div
                className="absolute top-full left-0 w-full mt-1 z-10 bg-white border shadow rounded"
                ref={dropdownRef.fontFamilyBox}
              >
                {fontFamilies.map((font) => (
                  <div
                    className="px-3 py-1 hover:bg-gray-100 cursor-pointer text-sm"
                    key={font}
                    onClick={() => {
                      updateTextStyle({ fontFamily: font });
                      // ToggleTextStyle("fontFamily");
                      setSelectedFont(font);
                      closeDropDown("fontFamilyBox");
                    }}
                  >
                    {font}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Font Size */}
        <div className="flex items-center relative gap-x-3">
          <span className="text-sm font-semibold text-black">Size</span>
          <div
            className="border flex items-center p-1 justify-between shadow-border rounded-lg h-[5vh] w-20 cursor-pointer bg-white relative"
            onClick={() => setDropdowns({ ...dropdowns, fontSizeBox: true })}
          >
            <span className="text-sm">{selectedSize}</span>
            <FaChevronDown size={10} />
            {dropdowns.fontSizeBox && (
              <div
                className="absolute top-full left-0 w-full mt-1 z-10 bg-white border shadow rounded"
                ref={dropdownRef.fontSizeBox}
              >
                {fontSizes.map((size) => (
                  <div
                    className="px-3 py-1 hover:bg-gray-100 cursor-pointer text-sm"
                    key={size}
                    onClick={() => {
                      updateTextStyle({ fontSize: Number(size) });
                      setSelectedSize(size);
                      closeDropDown("fontSizeBox");
                    }}
                  >
                    {size} pt
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-x-3">
          <button
            className="text-lg font-bold w-[25px] h-[25px] flex items-center justify-center hover:bg-gray-200 rounded-lg"
            onClick={() => ToggleTextStyle("fontWeight")}
            type="button"
          >
            B
          </button>
          <button
            className="italic font-normal text-lg w-[25px] h-[25px] flex items-center justify-center hover:bg-gray-200 rounded-lg"
            onClick={() => ToggleTextStyle("fontStyle")}
            type="button"
          >
            I
          </button>
          <button
            className="font-normal text-lg underline w-[25px] h-[25px] flex items-center justify-center hover:bg-gray-200 rounded-lg"
            onClick={() => ToggleTextStyle("underline")}
            type="button"
          >
            U
          </button>
        </div>
      </div>
      {downloadPdf && (
        <button
          className="px-4 py-2 font-medium w-fit  text-sm rounded-xl bg-gray-200 text-black"
          onClick={handleDownload}
          title="download pdf"
          type="button"
        >
          <FaDownload />
        </button>
      )}
    </div>
  );
}

export default TextToolbar;

//  "Helvetica, sans-serif",
//                         "Times, serif",
//                         "Courier, monospace",
